import axios from '@/utils/axios';

export const getFoods = async ({ commit }, params) => {

    await axios({
        method: "GET",
        url: `/groups/${params.id}/food_groups`,
        params: params
    })
        .then(response => {
            if (response.data) {
                const { data } = response;
                commit('setFoods', data["hydra:member"]);
                commit('setTotalItems', data['hydra:totalItems']);
            }
        })
        .catch(e => {
            console.log(e);
        });
};

export const getFoodById = async ({ commit }, id) => {

    commit('setCurrentFood', null);

    await axios({
        method: "GET",
        url: `/food_groups/${id}`
    })
        .then(response => {
            const { data } = response;
            commit('setCurrentFood', data);
        })
        .catch(e => {
            console.log(e);
        });
}

export const add = async (_, payload) => {

    return await axios({
        method: "POST",
        url: '/food_groups',
        data: payload
    })
        .then(response => {
            console.log(response);
        })
        .catch(e => {
            console.log(e);
        });
};

export const edit = async ({ commit }, payload) => {

    return await axios({
        method: "PUT",
        url: '/food_groups/' + payload['id'],
        data: payload,
    })
        .then((response) => {
            console.log(response);
            commit('setLoading', false);
        })
        .catch(e => {
            console.log(e);
        });
};

export const deleteFood = async ({ commit }, id) => {

    await axios({
        method: "DELETE",
        url: `/food_groups/${id}`
    })
        .then(response => {
            console.log(response);
            commit('setLoading', false);
        })
        .catch(e => {
            console.log(e);
        });
};